import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppointmentService } from 'src/app/modules/appointments/_services/appointments.service';
import { AuthService } from 'src/app/modules/auth';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit, OnDestroy  {
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = [];
  isLoading$: Observable<boolean>;
  @Input() AppoinmentId : number;
  @Input() AppointmentFlag : number;
  user$: Observable<AuthModel>;
  PatientId;
  GuestId;
  constructor(private translationService: TranslationService, private authService: AuthService,
    private toast: HotToastService,private AppointmentService : AppointmentService,
    private auth: AuthService,public modal: NgbActiveModal) { 
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.isLoading$ = this.authService.isLoading$;
   }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.user$.subscribe(res => {
      if (res.userId) {
        if (res.isGuest && res.iqamaId != null && res.iqamaId != '') {
          this.GuestId = res.userId;
          this.PatientId = 0;
        }
        else {
          
          this.PatientId = res.userId;
          this.GuestId = 0;
          
        }
      }
    })
  }
  onNoClick(): void {
    this.modal.close();
  }
  ConfirmOrCancelAppointment() {
    
    this.AppointmentService.showLoader();
    const Subscr = this.AppointmentService.ConfirmOrCancelAppointment(this.AppoinmentId,this.AppointmentFlag).pipe(
      catchError((errorMessage) => {
        this.authService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
        this.onNoClick();
        this.AppointmentService.fetch();
      }
      else if (res.error?.status == 401) {
        var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
        const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
          if (resl.userId && resl.userId != 0 && resl.userId != null) {
            this.ConfirmOrCancelAppointment();
          }
          else {
            if (this.language == "ar") {
              this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
            }
            else {
              this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
            }
          }
        });
        this.unsubscribe.push(RefreshToken);
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
    });
    this.unsubscribe.push(Subscr);
  }
  
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
